import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import AppTabItems from "./components/AppTabItems/appTabItems";
import { useAppSelector } from "./redux/stateHooks";
import { isAccountLoggedIn } from "./redux/reducers/accountSlice";
import { ICred } from "./types/login.types";
import { useLocalStorage } from "./hooks/useLocalStorage";
import { LocalStorageKeys } from "./utils/constant";
import Account from "./components/Account/account";
import Login from "./components/Login/login";
import Loading from "./components/Loader/loading";
import { isQueryLoading } from "./redux/reducers/objectSlice";

// A reusable component to handle protected routes
const PrivateRoute = ({ element: Component }: { element: JSX.Element }) => {
  const isLoggedIn = useAppSelector(isAccountLoggedIn);
  const [credentials] = useLocalStorage<ICred>(
    LocalStorageKeys.CREDENTIALS,
    null
  );

  // console.log("aaaa", credentials?.access_token, isLoggedIn);
  const isAuthenticated = !!credentials?.access_token || isLoggedIn;

  return isAuthenticated ? Component : <Navigate to="/login" replace />;
};

const AppRoutes = () => {
  const _isQueryLoading = useAppSelector(isQueryLoading);
  return (
    <>
      {!!_isQueryLoading && <Loading />}
      <Router>
        <Routes>
          <Route path="/" element={<PrivateRoute element={<Account />} />} />
          <Route
            path="/app-tabs-items-component/:tabname"
            element={<PrivateRoute element={<AppTabItems />} />}
          />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Router>
    </>
  );
};

export default AppRoutes;
